// Author Shi Wen Long
// Date 2024-06-03 09:49:12

class SithMesStoolPo {
    constructor({
                    id = null,
                    ids = '',
                    purchasingDocNumber = '',
                    purchasingDocItemNumber = '',
                    purchasingDocDate = '',
                    objectCreator = '',
                    creatorName = '',
                    purchasingGroup = '',
                    vendorAccountNumber = '',
                    vendorNameEn = '',
                    vendorNameZh = '',
                    incoterms1 = '',
                    incoterms2 = '',
                    deletion = '',
                    plant = '',
                    accountAssignmentCategory = '',
                    purchasingDocItemCategory = '',
                    materialNumber = '',
                    materialShortText = '',
                    materialBatchManagementIndicator = '',
                    materialMinRemainingShelfLife = '',
                    totalShelfLife = '',
                    purchaseOrderQuantity = '',
                    purchaseOrderUnit = '',
                    poGrQuantity = '',
                    poOpenGrQuantity = '',
                    itemCreateDate = '',
                    itemDeliveryDate = '',
                    storageLocation = '',
                    goodsReceiptProcessingTime = '',
                    purchaseRequisitionNumber = '',
                    purchaseRequisitionItemNumber = '',
                    prRequisitionDate = '',
                    prItemDeliveryDate = '',
                    requester = '',
                    costCenter = '',
                    profitCenter = '',
                    salesDocNumber = '',
                    salesDocumentItem = '',
                    wbsElement = '',
                    network = '',
                    orderNumber = '',
                    mItem = '',
                    confirmationCategory = '',
                    deliveryDateAbSap = '',
                    deliveryDateAb = '',
                    deliveryDateLaSap = '',
                    deliveryDateLa = '',
                    deliveryDateTbSap = '',
                    deliveryDateTb = '',
                    reference = '',
                    deliverLocation = '',
                    exceptionMessageNumber = '',
                    prdScheduleDate = '',
                    dlvSubtractSchedule = '',
                    releaseIndicator = '',
                    isUploadQualityFile = '',
                    uploadDate = '',
                    deliverStatus = '',
                    receiveStatus = '',
                    receiveDate = '',
                    vendorContract = '',
                    netOrderValue = '',
                    currencyKey = '',
                    isBuyerUploadedContract = '',
                    buyerUploadedContractTime = '',
                    confirmTime = '',
                    confirmCount = '',
                    remark = '',
                    poReport = '',
                    poContractReport = '',
                    poVendorContractReport = '',
                    poAsnReportList = '',
                    supportTime = '',
                    supportStatus = '',
                    qualityFileIds = '',
                    inspectionPoint = '',
                    extInspectionRequestAttachmentIds = '',
                    hasUnReadRequireDateChangeHistory = '',
                    isCritical = '',
                    poReportList = '',
                    poContractReportList = '',
                    poVendorContractReportList = '',
                    qualityFiles = '',
                }
                    = {}) {
        this.id = id;
        this.ids = ids;
        this.purchasingDocNumber = purchasingDocNumber;
        this.purchasingDocItemNumber = purchasingDocItemNumber;
        this.purchasingDocDate = purchasingDocDate;
        this.objectCreator = objectCreator;
        this.creatorName = creatorName;
        this.purchasingGroup = purchasingGroup;
        this.vendorAccountNumber = vendorAccountNumber;
        this.vendorNameEn = vendorNameEn;
        this.vendorNameZh = vendorNameZh;
        this.incoterms1 = incoterms1;
        this.incoterms2 = incoterms2;
        this.deletion = deletion;
        this.plant = plant;
        this.accountAssignmentCategory = accountAssignmentCategory;
        this.purchasingDocItemCategory = purchasingDocItemCategory;
        this.materialNumber = materialNumber;
        this.materialShortText = materialShortText;
        this.materialBatchManagementIndicator = materialBatchManagementIndicator;
        this.materialMinRemainingShelfLife = materialMinRemainingShelfLife;
        this.totalShelfLife = totalShelfLife;
        this.purchaseOrderQuantity = purchaseOrderQuantity;
        this.purchaseOrderUnit = purchaseOrderUnit;
        this.poGrQuantity = poGrQuantity;
        this.poOpenGrQuantity = poOpenGrQuantity;
        this.itemCreateDate = itemCreateDate;
        this.itemDeliveryDate = itemDeliveryDate;
        this.storageLocation = storageLocation;
        this.goodsReceiptProcessingTime = goodsReceiptProcessingTime;
        this.purchaseRequisitionNumber = purchaseRequisitionNumber;
        this.purchaseRequisitionItemNumber = purchaseRequisitionItemNumber;
        this.prRequisitionDate = prRequisitionDate;
        this.prItemDeliveryDate = prItemDeliveryDate;
        this.requester = requester;
        this.costCenter = costCenter;
        this.profitCenter = profitCenter;
        this.salesDocNumber = salesDocNumber;
        this.salesDocumentItem = salesDocumentItem;
        this.wbsElement = wbsElement;
        this.network = network;
        this.orderNumber = orderNumber;
        this.mItem = mItem;
        this.confirmationCategory = confirmationCategory;
        this.deliveryDateAbSap = deliveryDateAbSap;
        this.deliveryDateAb = deliveryDateAb;
        this.deliveryDateLaSap = deliveryDateLaSap;
        this.deliveryDateLa = deliveryDateLa;
        this.deliveryDateTbSap = deliveryDateTbSap;
        this.deliveryDateTb = deliveryDateTb;
        this.reference = reference;
        this.deliverLocation = deliverLocation;
        this.exceptionMessageNumber = exceptionMessageNumber;
        this.prdScheduleDate = prdScheduleDate;
        this.dlvSubtractSchedule = dlvSubtractSchedule;
        this.releaseIndicator = releaseIndicator;
        this.isUploadQualityFile = isUploadQualityFile;
        this.uploadDate = uploadDate;
        this.deliverStatus = deliverStatus;
        this.receiveStatus = receiveStatus;
        this.receiveDate = receiveDate;
        this.vendorContract = vendorContract;
        this.netOrderValue = netOrderValue;
        this.currencyKey = currencyKey;
        this.isBuyerUploadedContract = isBuyerUploadedContract;
        this.buyerUploadedContractTime = buyerUploadedContractTime;
        this.confirmTime = confirmTime;
        this.confirmCount = confirmCount;
        this.remark = remark;
        this.poReport = poReport;
        this.poContractReport = poContractReport;
        this.poVendorContractReport = poVendorContractReport;
        this.poAsnReportList = poAsnReportList;
        this.supportTime = supportTime;
        this.supportStatus = supportStatus;
        this.qualityFileIds = qualityFileIds;
        this.inspectionPoint = inspectionPoint;
        this.extInspectionRequestAttachmentIds = extInspectionRequestAttachmentIds;
        this.hasUnReadRequireDateChangeHistory = hasUnReadRequireDateChangeHistory;
        this.isCritical = isCritical;
        this.poReportList = poReportList;
        this.poContractReportList = poContractReportList;
        this.poVendorContractReportList = poVendorContractReportList;
        this.poAsnReportList = poAsnReportList;
        this.qualityFiles = qualityFiles;
        this.extInspectionRequestAttachmentIds = extInspectionRequestAttachmentIds;
    }
}

function newEntity() {
    return new SithMesStoolPo();
}

const cpmVoConfigs = [
    {
        key: 'purchasingDocNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchasingDocNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchasingDocItemNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectName',
        label: 'label.sith.stool.sithMesStoolPo.grid.projectName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.stool.sithMesStoolPo.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.wbsNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machine1',
        label: 'label.sith.stool.sithMesStoolPo.grid.machine1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pmName',
        label: 'label.sith.stool.sithMesStoolPo.grid.pmName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cpmName',
        label: 'label.sith.stool.sithMesStoolPo.grid.cpmName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omName',
        label: 'label.sith.stool.sithMesStoolPo.grid.omName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'engCoreCompressorName',
        label: 'label.sith.stool.sithMesStoolPo.grid.engCoreCompressorName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'engIcName',
        label: 'label.sith.stool.sithMesStoolPo.grid.engIcName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchasingDocDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'objectCreator',
        label: 'label.sith.stool.sithMesStoolPo.grid.objectCreator',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorName',
        label: 'label.sith.stool.sithMesStoolPo.grid.creatorName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingGroup',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchasingGroup',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorAccountNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.vendorAccountNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameEn',
        label: 'label.sith.stool.sithMesStoolPo.grid.vendorNameEn',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameZh',
        label: 'label.sith.stool.sithMesStoolPo.grid.vendorNameZh',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms1',
        label: 'label.sith.stool.sithMesStoolPo.grid.incoterms1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms2',
        label: 'label.sith.stool.sithMesStoolPo.grid.incoterms2',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deletion',
        label: 'label.sith.stool.sithMesStoolPo.grid.deletion',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plant',
        label: 'label.sith.stool.sithMesStoolPo.grid.plant',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'accountAssignmentCategory',
        label: 'label.sith.stool.sithMesStoolPo.grid.accountAssignmentCategory',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemCategory',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchasingDocItemCategory',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.materialNumber',
        sortable: true,
        form: {
            type: 'input',
            linkTo: 'material_bom',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bulk',
        label: 'label.sith.stool.sithMesStoolPo.grid.bulk',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialShortText',
        label: 'label.sith.stool.sithMesStoolPo.grid.materialShortText',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderQuantity',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchaseOrderQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderUnit',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchaseOrderUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poGrQuantity',
        label: 'label.sith.stool.sithMesStoolPo.grid.poGrQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poOpenGrQuantity',
        label: 'label.sith.stool.sithMesStoolPo.grid.poOpenGrQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCreateDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.itemCreateDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemDeliveryDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.itemDeliveryDate',
        sortable: true,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageLocation',
        label: 'label.sith.stool.sithMesStoolPo.grid.storageLocation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'goodsReceiptProcessingTime',
        label: 'label.sith.stool.sithMesStoolPo.grid.goodsReceiptProcessingTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchaseRequisitionNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionItemNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchaseRequisitionItemNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prRequisitionDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.prRequisitionDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemDeliveryDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.prItemDeliveryDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requester',
        label: 'label.sith.stool.sithMesStoolPo.grid.requester',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'costCenter',
        label: 'label.sith.stool.sithMesStoolPo.grid.costCenter',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'profitCenter',
        label: 'label.sith.stool.sithMesStoolPo.grid.profitCenter',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesDocNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.salesDocNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesDocumentItem',
        label: 'label.sith.stool.sithMesStoolPo.grid.salesDocumentItem',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsElement',
        label: 'label.sith.stool.sithMesStoolPo.grid.wbsElement',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'network',
        label: 'label.sith.stool.sithMesStoolPo.grid.network',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.orderNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mItem',
        label: 'label.sith.stool.sithMesStoolPo.grid.mItem',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmationCategory',
        label: 'label.sith.stool.sithMesStoolPo.grid.confirmationCategory',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbSap',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateAbSap',
        sortable: true,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAb',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateAb',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaSap',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateLaSap',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLa',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateLa',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbSap',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateTbSap',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTb',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateTb',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'reference',
        label: 'label.sith.stool.sithMesStoolPo.grid.reference',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverLocation',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliverLocation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'exceptionMessageNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.exceptionMessageNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdScheduleDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.prdScheduleDate',
        sortable: true,
        form: {
            type: 'datepicker',
            linkTo: 'common_link',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dlvSubtractSchedule',
        label: 'label.sith.stool.sithMesStoolPo.grid.dlvSubtractSchedule',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'releaseIndicator',
        label: 'label.sith.stool.sithMesStoolPo.grid.releaseIndicator',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isUploadQualityFile',
        label: 'label.sith.stool.sithMesStoolPo.grid.isUploadQualityFile',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'uploadDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.uploadDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverStatus',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliverStatus',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiveDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.receiveDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTime',
        label: 'label.sith.stool.sithMesStoolPo.grid.incomingTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate103',
        label: 'label.sith.stool.sithMesStoolPo.grid.receivingDate103',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorContract',
        label: 'label.sith.stool.sithMesStoolPo.grid.vendorContract',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '已上传'},
                {value: '2', text: '未上传'}
            ]
        }
    },
    {
        key: 'netOrderValue',
        label: 'label.sith.stool.sithMesStoolPo.grid.netOrderValue',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'currencyKey',
        label: 'label.sith.stool.sithMesStoolPo.grid.currencyKey',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPo.grid.remark',
        sortable: true,
        isDetail: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poReportList',
        label: 'label.sith.stool.sithMesStoolPo.grid.poReportList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poContractReportList',
        label: 'label.sith.stool.sithMesStoolPo.grid.poContractReportList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poVendorContractReportList',
        label: 'label.sith.stool.sithMesStoolPo.grid.poVendorContractReportList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isAsn',
        label: 'label.sith.stool.sithMesStoolPo.grid.isAsn',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isSame',
        label: 'label.sith.stool.sithMesStoolPo.grid.isSame',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isBuyerUploadedContract',
        label: 'label.sith.stool.sithMesStoolPo.grid.isBuyerUploadedContract',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'buyerUploadedContractTime',
        label: 'label.sith.stool.sithMesStoolPo.grid.buyerUploadedContractTime',
        sortable: true,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmTime',
        label: 'label.sith.stool.sithMesStoolPo.grid.confirmTime',
        sortable: true,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnSapDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.returnSapDate',
        sortable: true,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmCount',
        label: 'label.sith.stool.sithMesStoolPo.grid.confirmCount',
        sortable: true,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poAsnReportList',
        label: 'label.sith.stool.sithMesStoolPo.grid.poAsnReportList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportTime',
        label: 'label.sith.stool.sithMesStoolPo.grid.supportTime',
        sortable: true,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportStatus',
        label: 'label.sith.stool.sithMesStoolPo.grid.supportStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '未维护'},
                {value: '1', text: '已维护'}
            ]
        }
    },
    {
        key: 'qualityFiles',
        label: 'label.sith.stool.sithMesStoolPo.grid.qualityFiles',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionPoint',
        label: 'label.sith.stool.sithMesStoolPo.grid.inspectionPoint',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'extInspectionRequestAttachments',
        label: 'label.sith.stool.sithMesStoolPo.grid.extInspectionRequestAttachments',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastModifiedExtInspectionInspectorName',
        label: 'label.sith.stool.sithMesStoolPo.grid.lastModifiedExtInspectionInspectorName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastModifiedExtInspectionStatus',
        label: 'label.sith.stool.sithMesStoolPo.grid.lastModifiedExtInspectionStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '未检验'},
                {value: '1', text: '检验合格'},
                {value: '2', text: '检验不合格'},
                {value: '3', text: '放弃检验'}
            ]
        }
    },
    {
        key: 'hasGenerateDeliverList',
        label: 'label.sith.stool.sithMesStoolPo.grid.hasGenerateDeliverList',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
]

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.stool.sithMesStoolPo.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchasingDocNumber',
            label: 'label.sith.stool.sithMesStoolPo.grid.purchasingDocNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchasingDocItemNumber',
            label: 'label.sith.stool.sithMesStoolPo.grid.purchasingDocItemNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectName',
            label: 'label.sith.stool.sithMesStoolPo.grid.projectName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.stool.sithMesStoolPo.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbsNumber',
            label: 'label.sith.stool.sithMesStoolPo.grid.wbsNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'machine1',
            label: 'label.sith.stool.sithMesStoolPo.grid.machine1',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'pmName',
            label: 'label.sith.stool.sithMesStoolPo.grid.pmName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'cpmName',
            label: 'label.sith.stool.sithMesStoolPo.grid.cpmName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'omName',
            label: 'label.sith.stool.sithMesStoolPo.grid.omName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'engCoreCompressorName',
            label: 'label.sith.stool.sithMesStoolPo.grid.engCoreCompressorName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'engIcName',
            label: 'label.sith.stool.sithMesStoolPo.grid.engIcName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchasingDocDate',
            label: 'label.sith.stool.sithMesStoolPo.grid.purchasingDocDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'objectCreator',
            label: 'label.sith.stool.sithMesStoolPo.grid.objectCreator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'creatorName',
            label: 'label.sith.stool.sithMesStoolPo.grid.creatorName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchasingGroup',
            label: 'label.sith.stool.sithMesStoolPo.grid.purchasingGroup',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorAccountNumber',
            label: 'label.sith.stool.sithMesStoolPo.grid.vendorAccountNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorNameEn',
            label: 'label.sith.stool.sithMesStoolPo.grid.vendorNameEn',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorNameZh',
            label: 'label.sith.stool.sithMesStoolPo.grid.vendorNameZh',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'incoterms1',
            label: 'label.sith.stool.sithMesStoolPo.grid.incoterms1',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'incoterms2',
            label: 'label.sith.stool.sithMesStoolPo.grid.incoterms2',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deletion',
            label: 'label.sith.stool.sithMesStoolPo.grid.deletion',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'plant',
            label: 'label.sith.stool.sithMesStoolPo.grid.plant',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'accountAssignmentCategory',
            label: 'label.sith.stool.sithMesStoolPo.grid.accountAssignmentCategory',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchasingDocItemCategory',
            label: 'label.sith.stool.sithMesStoolPo.grid.purchasingDocItemCategory',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialNumber',
            label: 'label.sith.stool.sithMesStoolPo.grid.materialNumber',
            sortable: true,
            form: {
                type: 'input',
                linkTo: 'material_bom',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bulk',
            label: 'label.sith.stool.sithMesStoolPo.grid.bulk',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialShortText',
            label: 'label.sith.stool.sithMesStoolPo.grid.materialShortText',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialBatchManagementIndicator',
            label: 'label.sith.stool.sithMesStoolPo.grid.materialBatchManagementIndicator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialMinRemainingShelfLife',
            label: 'label.sith.stool.sithMesStoolPo.grid.materialMinRemainingShelfLife',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'totalShelfLife',
            label: 'label.sith.stool.sithMesStoolPo.grid.totalShelfLife',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchaseOrderQuantity',
            label: 'label.sith.stool.sithMesStoolPo.grid.purchaseOrderQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchaseOrderUnit',
            label: 'label.sith.stool.sithMesStoolPo.grid.purchaseOrderUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poGrQuantity',
            label: 'label.sith.stool.sithMesStoolPo.grid.poGrQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poOpenGrQuantity',
            label: 'label.sith.stool.sithMesStoolPo.grid.poOpenGrQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemCreateDate',
            label: 'label.sith.stool.sithMesStoolPo.grid.itemCreateDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemDeliveryDate',
            label: 'label.sith.stool.sithMesStoolPo.grid.itemDeliveryDate',
            sortable: true,
            form: {
                type: 'datepicker',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageLocation',
            label: 'label.sith.stool.sithMesStoolPo.grid.storageLocation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'goodsReceiptProcessingTime',
            label: 'label.sith.stool.sithMesStoolPo.grid.goodsReceiptProcessingTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchaseRequisitionNumber',
            label: 'label.sith.stool.sithMesStoolPo.grid.purchaseRequisitionNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchaseRequisitionItemNumber',
            label: 'label.sith.stool.sithMesStoolPo.grid.purchaseRequisitionItemNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prRequisitionDate',
            label: 'label.sith.stool.sithMesStoolPo.grid.prRequisitionDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prItemDeliveryDate',
            label: 'label.sith.stool.sithMesStoolPo.grid.prItemDeliveryDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'requester',
            label: 'label.sith.stool.sithMesStoolPo.grid.requester',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'costCenter',
            label: 'label.sith.stool.sithMesStoolPo.grid.costCenter',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'profitCenter',
            label: 'label.sith.stool.sithMesStoolPo.grid.profitCenter',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesDocNumber',
            label: 'label.sith.stool.sithMesStoolPo.grid.salesDocNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesDocumentItem',
            label: 'label.sith.stool.sithMesStoolPo.grid.salesDocumentItem',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbsElement',
            label: 'label.sith.stool.sithMesStoolPo.grid.wbsElement',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'network',
            label: 'label.sith.stool.sithMesStoolPo.grid.network',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderNumber',
            label: 'label.sith.stool.sithMesStoolPo.grid.orderNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mItem',
            label: 'label.sith.stool.sithMesStoolPo.grid.mItem',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'confirmationCategory',
            label: 'label.sith.stool.sithMesStoolPo.grid.confirmationCategory',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryDateAbSap',
            label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateAbSap',
            sortable: true,
            form: {
                type: 'datepicker',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryDateAb',
            label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateAb',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryDateLaSap',
            label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateLaSap',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryDateLa',
            label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateLa',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryDateTbSap',
            label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateTbSap',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryDateTb',
            label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateTb',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'reference',
            label: 'label.sith.stool.sithMesStoolPo.grid.reference',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliverLocation',
            label: 'label.sith.stool.sithMesStoolPo.grid.deliverLocation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'exceptionMessageNumber',
            label: 'label.sith.stool.sithMesStoolPo.grid.exceptionMessageNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prdScheduleDate',
            label: 'label.sith.stool.sithMesStoolPo.grid.prdScheduleDate',
            sortable: true,
            form: {
                type: 'datepicker',
                linkTo: 'common_link',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dlvSubtractSchedule',
            label: 'label.sith.stool.sithMesStoolPo.grid.dlvSubtractSchedule',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'releaseIndicator',
            label: 'label.sith.stool.sithMesStoolPo.grid.releaseIndicator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isUploadQualityFile',
            label: 'label.sith.stool.sithMesStoolPo.grid.isUploadQualityFile',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'uploadDate',
            label: 'label.sith.stool.sithMesStoolPo.grid.uploadDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliverStatus',
            label: 'label.sith.stool.sithMesStoolPo.grid.deliverStatus',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'receiveStatus',
            label: 'label.sith.stool.sithMesStoolPo.grid.receiveStatus',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'receiveDate',
            label: 'label.sith.stool.sithMesStoolPo.grid.receiveDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'incomingTime',
            label: 'label.sith.stool.sithMesStoolPo.grid.incomingTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'receivingDate103',
            label: 'label.sith.stool.sithMesStoolPo.grid.receivingDate103',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorContract',
            label: 'label.sith.stool.sithMesStoolPo.grid.vendorContract',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '已上传'},
                    {value: '2', text: '未上传'}
                ]
            }
        },
        {
            key: 'netOrderValue',
            label: 'label.sith.stool.sithMesStoolPo.grid.netOrderValue',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'currencyKey',
            label: 'label.sith.stool.sithMesStoolPo.grid.currencyKey',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.stool.sithMesStoolPo.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poReportList',
            label: 'label.sith.stool.sithMesStoolPo.grid.poReportList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poContractReportList',
            label: 'label.sith.stool.sithMesStoolPo.grid.poContractReportList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poVendorContractReportList',
            label: 'label.sith.stool.sithMesStoolPo.grid.poVendorContractReportList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isAsn',
            label: 'label.sith.stool.sithMesStoolPo.grid.isAsn',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isSame',
            label: 'label.sith.stool.sithMesStoolPo.grid.isSame',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isBuyerUploadedContract',
            label: 'label.sith.stool.sithMesStoolPo.grid.isBuyerUploadedContract',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'buyerUploadedContractTime',
            label: 'label.sith.stool.sithMesStoolPo.grid.buyerUploadedContractTime',
            sortable: true,
            form: {
                type: 'datepicker',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'confirmTime',
            label: 'label.sith.stool.sithMesStoolPo.grid.confirmTime',
            sortable: true,
            form: {
                type: 'datepicker',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'returnSapDate',
            label: 'label.sith.stool.sithMesStoolPo.grid.returnSapDate',
            sortable: true,
            form: {
                type: 'datetimepicker',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'confirmCount',
            label: 'label.sith.stool.sithMesStoolPo.grid.confirmCount',
            sortable: true,
            form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poAsnReportList',
            label: 'label.sith.stool.sithMesStoolPo.grid.poAsnReportList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'supportTime',
            label: 'label.sith.stool.sithMesStoolPo.grid.supportTime',
            sortable: true,
            form: {
                type: 'datetimepicker',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'supportStatus',
            label: 'label.sith.stool.sithMesStoolPo.grid.supportStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '未维护'},
                    {value: '1', text: '已维护'}
                ]
            }
        },
        {
            key: 'qualityFiles',
            label: 'label.sith.stool.sithMesStoolPo.grid.qualityFiles',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inspectionPoint',
            label: 'label.sith.stool.sithMesStoolPo.grid.inspectionPoint',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'extInspectionRequestAttachments',
            label: 'label.sith.stool.sithMesStoolPo.grid.extInspectionRequestAttachments',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'lastModifiedExtInspectionInspectorName',
            label: 'label.sith.stool.sithMesStoolPo.grid.lastModifiedExtInspectionInspectorName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'lastModifiedExtInspectionStatus',
            label: 'label.sith.stool.sithMesStoolPo.grid.lastModifiedExtInspectionStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '未检验'},
                    {value: '1', text: '检验合格'},
                    {value: '2', text: '检验不合格'},
                    {value: '3', text: '放弃检验'}
                ]
            }
        },
        {
            key: 'hasGenerateDeliverList',
            label: 'label.sith.stool.sithMesStoolPo.grid.hasGenerateDeliverList',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sdc',
            label: 'label.sith.stool.sithMesStoolPo.grid.sdc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sdcOtd',
            label: 'label.sith.stool.sithMesStoolPo.grid.sdcOtd',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sdr',
            label: 'label.sith.stool.sithMesStoolPo.grid.sdr',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sdrOtd',
            label: 'label.sith.stool.sithMesStoolPo.grid.sdrOtd',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isCritical',
            label: 'label.sith.stool.sithMesStoolPo.grid.isCritical',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const vendorVoConfigs = [
    {
        key: 'id',
        label: 'label.sith.stool.sithMesStoolPo.grid.id',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchasingDocNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchasingDocItemNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.stool.sithMesStoolPo.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machine1',
        label: 'label.sith.stool.sithMesStoolPo.grid.machine1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pmName',
        label: 'label.sith.stool.sithMesStoolPo.grid.pmName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'engCoreCompressorName',
        label: 'label.sith.stool.sithMesStoolPo.grid.engCoreCompressorName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'engIcName',
        label: 'label.sith.stool.sithMesStoolPo.grid.engIcName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'objectCreator',
        label: 'label.sith.stool.sithMesStoolPo.grid.objectCreator',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorName',
        label: 'label.sith.stool.sithMesStoolPo.grid.creatorName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingGroup',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchasingGroup',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorAccountNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.vendorAccountNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameEn',
        label: 'label.sith.stool.sithMesStoolPo.grid.vendorNameEn',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameZh',
        label: 'label.sith.stool.sithMesStoolPo.grid.vendorNameZh',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms1',
        label: 'label.sith.stool.sithMesStoolPo.grid.incoterms1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms2',
        label: 'label.sith.stool.sithMesStoolPo.grid.incoterms2',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deletion',
        label: 'label.sith.stool.sithMesStoolPo.grid.deletion',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'accountAssignmentCategory',
        label: 'label.sith.stool.sithMesStoolPo.grid.accountAssignmentCategory',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemCategory',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchasingDocItemCategory',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.materialNumber',
        sortable: true,
        form: {
            type: 'input',
            linkTo: 'material_bom',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bulk',
        label: 'label.sith.stool.sithMesStoolPo.grid.bulk',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialShortText',
        label: 'label.sith.stool.sithMesStoolPo.grid.materialShortText',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderQuantity',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchaseOrderQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderUnit',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchaseOrderUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poGrQuantity',
        label: 'label.sith.stool.sithMesStoolPo.grid.poGrQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poOpenGrQuantity',
        label: 'label.sith.stool.sithMesStoolPo.grid.poOpenGrQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCreateDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.itemCreateDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemDeliveryDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.itemDeliveryDate',
        sortable: true,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchaseRequisitionNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionItemNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchaseRequisitionItemNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requester',
        label: 'label.sith.stool.sithMesStoolPo.grid.requester',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsElement',
        label: 'label.sith.stool.sithMesStoolPo.grid.wbsElement',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.orderNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mItem',
        label: 'label.sith.stool.sithMesStoolPo.grid.mItem',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmationCategory',
        label: 'label.sith.stool.sithMesStoolPo.grid.confirmationCategory',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbSap',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateAbSap',
        sortable: true,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAb',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateAb',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaSap',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateLaSap',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLa',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateLa',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbSap',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateTbSap',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTb',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateTb',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'reference',
        label: 'label.sith.stool.sithMesStoolPo.grid.reference',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverLocation',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliverLocation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdScheduleDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.prdScheduleDate',
        sortable: true,
        form: {
            type: 'datepicker',
            linkTo: 'common_link',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dlvSubtractSchedule',
        label: 'label.sith.stool.sithMesStoolPo.grid.dlvSubtractSchedule',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isUploadQualityFile',
        label: 'label.sith.stool.sithMesStoolPo.grid.isUploadQualityFile',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'uploadDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.uploadDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverStatus',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliverStatus',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiveStatus',
        label: 'label.sith.stool.sithMesStoolPo.grid.receiveStatus',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiveDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.receiveDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTime',
        label: 'label.sith.stool.sithMesStoolPo.grid.incomingTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate103',
        label: 'label.sith.stool.sithMesStoolPo.grid.receivingDate103',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorContract',
        label: 'label.sith.stool.sithMesStoolPo.grid.vendorContract',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '已上传'},
                {value: '2', text: '未上传'}
            ]
        }
    },
    {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPo.grid.remark',
        sortable: true,
        isDetail: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poReportList',
        label: 'label.sith.stool.sithMesStoolPo.grid.poReportList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poContractReportList',
        label: 'label.sith.stool.sithMesStoolPo.grid.poContractReportList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poVendorContractReportList',
        label: 'label.sith.stool.sithMesStoolPo.grid.poVendorContractReportList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isSame',
        label: 'label.sith.stool.sithMesStoolPo.grid.isSame',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'buyerUploadedContractTime',
        label: 'label.sith.stool.sithMesStoolPo.grid.buyerUploadedContractTime',
        sortable: true,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmTime',
        label: 'label.sith.stool.sithMesStoolPo.grid.confirmTime',
        sortable: true,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnSapDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.returnSapDate',
        sortable: true,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmCount',
        label: 'label.sith.stool.sithMesStoolPo.grid.confirmCount',
        sortable: true,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportTime',
        label: 'label.sith.stool.sithMesStoolPo.grid.supportTime',
        sortable: true,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportStatus',
        label: 'label.sith.stool.sithMesStoolPo.grid.supportStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '未维护'},
                {value: '1', text: '已维护'}
            ]
        }
    },
    {
        key: 'qualityFiles',
        label: 'label.sith.stool.sithMesStoolPo.grid.qualityFiles',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionPoint',
        label: 'label.sith.stool.sithMesStoolPo.grid.inspectionPoint',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'extInspectionRequestAttachments',
        label: 'label.sith.stool.sithMesStoolPo.grid.extInspectionRequestAttachments',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastModifiedExtInspectionInspectorName',
        label: 'label.sith.stool.sithMesStoolPo.grid.lastModifiedExtInspectionInspectorName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastModifiedExtInspectionStatus',
        label: 'label.sith.stool.sithMesStoolPo.grid.lastModifiedExtInspectionStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '未检验'},
                {value: '1', text: '检验合格'},
                {value: '2', text: '检验不合格'},
                {value: '3', text: '放弃检验'}
            ]
        }
    },
    {
        key: 'hasGenerateDeliverList',
        label: 'label.sith.stool.sithMesStoolPo.grid.hasGenerateDeliverList',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
]
const sithVoConfigs = [
    {
        key: 'id',
        label: 'label.sith.stool.sithMesStoolPo.grid.id',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchasingDocNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchasingDocItemNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectName',
        label: 'label.sith.stool.sithMesStoolPo.grid.projectName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.stool.sithMesStoolPo.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.wbsNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machine1',
        label: 'label.sith.stool.sithMesStoolPo.grid.machine1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pmName',
        label: 'label.sith.stool.sithMesStoolPo.grid.pmName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cpmName',
        label: 'label.sith.stool.sithMesStoolPo.grid.cpmName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omName',
        label: 'label.sith.stool.sithMesStoolPo.grid.omName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'engCoreCompressorName',
        label: 'label.sith.stool.sithMesStoolPo.grid.engCoreCompressorName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'engIcName',
        label: 'label.sith.stool.sithMesStoolPo.grid.engIcName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchasingDocDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'objectCreator',
        label: 'label.sith.stool.sithMesStoolPo.grid.objectCreator',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorName',
        label: 'label.sith.stool.sithMesStoolPo.grid.creatorName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingGroup',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchasingGroup',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorAccountNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.vendorAccountNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameEn',
        label: 'label.sith.stool.sithMesStoolPo.grid.vendorNameEn',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameZh',
        label: 'label.sith.stool.sithMesStoolPo.grid.vendorNameZh',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms1',
        label: 'label.sith.stool.sithMesStoolPo.grid.incoterms1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms2',
        label: 'label.sith.stool.sithMesStoolPo.grid.incoterms2',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deletion',
        label: 'label.sith.stool.sithMesStoolPo.grid.deletion',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plant',
        label: 'label.sith.stool.sithMesStoolPo.grid.plant',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'accountAssignmentCategory',
        label: 'label.sith.stool.sithMesStoolPo.grid.accountAssignmentCategory',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemCategory',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchasingDocItemCategory',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.materialNumber',
        sortable: true,
        form: {
            type: 'input',
            linkTo: 'material_bom',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bulk',
        label: 'label.sith.stool.sithMesStoolPo.grid.bulk',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialShortText',
        label: 'label.sith.stool.sithMesStoolPo.grid.materialShortText',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderQuantity',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchaseOrderQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderUnit',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchaseOrderUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poGrQuantity',
        label: 'label.sith.stool.sithMesStoolPo.grid.poGrQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poOpenGrQuantity',
        label: 'label.sith.stool.sithMesStoolPo.grid.poOpenGrQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCreateDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.itemCreateDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemDeliveryDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.itemDeliveryDate',
        sortable: true,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageLocation',
        label: 'label.sith.stool.sithMesStoolPo.grid.storageLocation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'goodsReceiptProcessingTime',
        label: 'label.sith.stool.sithMesStoolPo.grid.goodsReceiptProcessingTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchaseRequisitionNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionItemNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.purchaseRequisitionItemNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prRequisitionDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.prRequisitionDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemDeliveryDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.prItemDeliveryDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requester',
        label: 'label.sith.stool.sithMesStoolPo.grid.requester',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'costCenter',
        label: 'label.sith.stool.sithMesStoolPo.grid.costCenter',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'profitCenter',
        label: 'label.sith.stool.sithMesStoolPo.grid.profitCenter',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesDocNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.salesDocNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesDocumentItem',
        label: 'label.sith.stool.sithMesStoolPo.grid.salesDocumentItem',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsElement',
        label: 'label.sith.stool.sithMesStoolPo.grid.wbsElement',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'network',
        label: 'label.sith.stool.sithMesStoolPo.grid.network',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.orderNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mItem',
        label: 'label.sith.stool.sithMesStoolPo.grid.mItem',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmationCategory',
        label: 'label.sith.stool.sithMesStoolPo.grid.confirmationCategory',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbSap',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateAbSap',
        sortable: true,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAb',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateAb',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaSap',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateLaSap',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLa',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateLa',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbSap',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateTbSap',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTb',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliveryDateTb',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'reference',
        label: 'label.sith.stool.sithMesStoolPo.grid.reference',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverLocation',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliverLocation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'exceptionMessageNumber',
        label: 'label.sith.stool.sithMesStoolPo.grid.exceptionMessageNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdScheduleDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.prdScheduleDate',
        sortable: true,
        form: {
            type: 'datepicker',
            linkTo: 'common_link',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dlvSubtractSchedule',
        label: 'label.sith.stool.sithMesStoolPo.grid.dlvSubtractSchedule',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'releaseIndicator',
        label: 'label.sith.stool.sithMesStoolPo.grid.releaseIndicator',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isUploadQualityFile',
        label: 'label.sith.stool.sithMesStoolPo.grid.isUploadQualityFile',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'uploadDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.uploadDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverStatus',
        label: 'label.sith.stool.sithMesStoolPo.grid.deliverStatus',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiveStatus',
        label: 'label.sith.stool.sithMesStoolPo.grid.receiveStatus',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiveDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.receiveDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTime',
        label: 'label.sith.stool.sithMesStoolPo.grid.incomingTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate103',
        label: 'label.sith.stool.sithMesStoolPo.grid.receivingDate103',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorContract',
        label: 'label.sith.stool.sithMesStoolPo.grid.vendorContract',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '已上传'},
                {value: '2', text: '未上传'}
            ]
        }
    },
    {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPo.grid.remark',
        sortable: true,
        isDetail: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poReportList',
        label: 'label.sith.stool.sithMesStoolPo.grid.poReportList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poContractReportList',
        label: 'label.sith.stool.sithMesStoolPo.grid.poContractReportList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poVendorContractReportList',
        label: 'label.sith.stool.sithMesStoolPo.grid.poVendorContractReportList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isAsn',
        label: 'label.sith.stool.sithMesStoolPo.grid.isAsn',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isSame',
        label: 'label.sith.stool.sithMesStoolPo.grid.isSame',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isBuyerUploadedContract',
        label: 'label.sith.stool.sithMesStoolPo.grid.isBuyerUploadedContract',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'buyerUploadedContractTime',
        label: 'label.sith.stool.sithMesStoolPo.grid.buyerUploadedContractTime',
        sortable: true,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmTime',
        label: 'label.sith.stool.sithMesStoolPo.grid.confirmTime',
        sortable: true,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnSapDate',
        label: 'label.sith.stool.sithMesStoolPo.grid.returnSapDate',
        sortable: true,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmCount',
        label: 'label.sith.stool.sithMesStoolPo.grid.confirmCount',
        sortable: true,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poAsnReportList',
        label: 'label.sith.stool.sithMesStoolPo.grid.poAsnReportList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportTime',
        label: 'label.sith.stool.sithMesStoolPo.grid.supportTime',
        sortable: true,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportStatus',
        label: 'label.sith.stool.sithMesStoolPo.grid.supportStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '未维护'},
                {value: '1', text: '已维护'}
            ]
        }
    },
    {
        key: 'qualityFiles',
        label: 'label.sith.stool.sithMesStoolPo.grid.qualityFiles',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionPoint',
        label: 'label.sith.stool.sithMesStoolPo.grid.inspectionPoint',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'extInspectionRequestAttachments',
        label: 'label.sith.stool.sithMesStoolPo.grid.extInspectionRequestAttachments',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastModifiedExtInspectionInspectorName',
        label: 'label.sith.stool.sithMesStoolPo.grid.lastModifiedExtInspectionInspectorName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastModifiedExtInspectionStatus',
        label: 'label.sith.stool.sithMesStoolPo.grid.lastModifiedExtInspectionStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '未检验'},
                {value: '1', text: '检验合格'},
                {value: '2', text: '检验不合格'},
                {value: '3', text: '放弃检验'}
            ]
        }
    },
    {
        key: 'hasGenerateDeliverList',
        label: 'label.sith.stool.sithMesStoolPo.grid.hasGenerateDeliverList',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sdc',
        label: 'label.sith.stool.sithMesStoolPo.grid.sdc',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sdcOtd',
        label: 'label.sith.stool.sithMesStoolPo.grid.sdcOtd',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sdr',
        label: 'label.sith.stool.sithMesStoolPo.grid.sdr',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sdrOtd',
        label: 'label.sith.stool.sithMesStoolPo.grid.sdrOtd',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isCritical',
        label: 'label.sith.stool.sithMesStoolPo.grid.isCritical',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    }
]

const filter = {
    idFilter: '',
    idListFilter: [],
    prListFilter: [],
    purchasingDocNumberFilter: '',
    purchasingDocItemNumberFilter: '',
    purchasingDocDateRteFilter: '',
    purchasingDocDateLteFilter: '',
    objectCreatorFilter: '',
    creatorNameFilter: '',
    purchasingGroupFilter: '',
    vendorAccountNumberFilter: '',
    vendorNameEnFilter: '',
    vendorNameZhFilter: '',
    incoterms1Filter: '',
    incoterms2Filter: '',
    plantFilter: '',
    accountAssignmentCategoryFilter: '',
    purchasingDocItemCategoryFilter: '',
    materialNumberFilter: '',
    bulkFilter: '',
    materialShortTextFilter: '',
    materialBatchManagementIndicatorFilter: '',
    materialMinRemainingShelfLifeFilter: '',
    totalShelfLifeFilter: '',
    purchaseOrderQuantityFilter: '',
    purchaseOrderUnitFilter: '',
    poGrQuantityFilter: '',
    poOpenGrQuantityFilter: '',
    itemCreateDateRteFilter: '',
    itemCreateDateLteFilter: '',
    itemDeliveryDateRteFilter: '',
    itemDeliveryDateLteFilter: '',
    storageLocationFilter: '',
    goodsReceiptProcessingTimeFilter: '',
    purchaseRequisitionNumberFilter: '',
    purchaseRequisitionItemNumberFilter: '',
    prRequisitionDateRteFilter: '',
    prRequisitionDateLteFilter: '',
    prItemDeliveryDateRteFilter: '',
    prItemDeliveryDateLteFilter: '',
    requesterFilter: '',
    costCenterFilter: '',
    profitCenterFilter: '',
    salesDocNumberFilter: '',
    salesDocumentItemFilter: '',
    wbsElementFilter: '',
    networkFilter: '',
    orderNumberFilter: '',
    mItemFilter: '',
    confirmationCategoryFilter: '',
    deliveryDateAbSapRteFilter: '',
    deliveryDateAbSapLteFilter: '',
    deliveryDateAbRteFilter: '',
    deliveryDateAbLteFilter: '',
    deliveryDateLaSapRteFilter: '',
    deliveryDateLaSapLteFilter: '',
    deliveryDateLaRteFilter: '',
    deliveryDateLaLteFilter: '',
    deliveryDateTbSapRteFilter: '',
    deliveryDateTbSapLteFilter: '',
    deliveryDateTbRteFilter: '',
    deliveryDateTbLteFilter: '',
    referenceFilter: '',
    deliverLocationFilter: '',
    exceptionMessageNumberFilter: '',
    prdScheduleDateRteFilter: '',
    prdScheduleDateLteFilter: '',
    dlvSubtractScheduleFilter: '',
    deliveryDateIsOnTimeFilter: '',
    gteZeroFilter: '',
    ltZeroFilter: '',
    releaseIndicatorFilter: '',
    isUploadQualityFileFilter: '',
    uploadDateFilter: '',
    deliverStatusFilter: '',
    receiveStatusFilter: '',
    receiveDateRteFilter: '',
    receiveDateLteFilter: '',
    incomingTimeRteFilter: '',
    incomingTimeLteFilter: '',
    vendorContractFilter: '',
    isOpenFilter: '',
    netOrderValueFilter: '',
    currencyKeyFilter: '',
    isAsnFilter: '',
    isSameFilter: '',
    isBuyerUploadedContractFilter: '',
    buyerUploadedContractTimeRteFilter: '',
    buyerUploadedContractTimeLteFilter: '',
    returnSapDateRteFilter: '',
    returnSapDateLteFilter: '',
    isConfirmSapFilter: '',
    confirmTimeRteFilter: '',
    confirmTimeLteFilter: '',
    confirmCountFilter: '',
    supportTimeRteFilter: '',
    supportTimeLteFilter: '',
    supportStatusFilter: '',
    confirmCountIsZeroFilter: '',
    projectNameFilter: '',
    projectCodeFilter: '',
    pmFilter: '',
    cpmFilter: '',
    omFilter: '',
    pmNameFilter: '',
    cpmNameFilter: '',
    omNameFilter: '',
    lastModifiedExtInspectionInspectorNameFilter: '',
    lastModifiedExtInspectionStatusFilter: '',
    hasGenerateDeliverListFilter: '',
    filterByNeedReadRequireDateChangeHistoryFilter: '',
    deliverTaskIdFilter: '',
    userGroupIdFilter: '',
    sdcOtdFilter: '',
    sdrOtdFilter: '',
    isCriticalFilter: '',
    deletionFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'purchasingDocNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocItemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'objectCreatorFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.objectCreator',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.creatorName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingGroupFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingGroup',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorAccountNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorAccountNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameEnFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorNameEn',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameZhFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorNameZh',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms1Filter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incoterms1',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms2Filter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incoterms2',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plantFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.plant',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'accountAssignmentCategoryFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.accountAssignmentCategory',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemCategoryFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocItemCategory',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.materialNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bulkFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.bulk',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialShortTextFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.materialShortText',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialBatchManagementIndicatorFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.materialBatchManagementIndicator',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialMinRemainingShelfLifeFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.materialMinRemainingShelfLife',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'totalShelfLifeFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.totalShelfLife',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderQuantityFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseOrderQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderUnitFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseOrderUnit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poGrQuantityFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.poGrQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poOpenGrQuantityFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.poOpenGrQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCreateDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemCreateDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCreateDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemCreateDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemDeliveryDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemDeliveryDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemDeliveryDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemDeliveryDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageLocationFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.storageLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'goodsReceiptProcessingTimeFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.goodsReceiptProcessingTime',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseRequisitionNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionItemNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseRequisitionItemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prRequisitionDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prRequisitionDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prRequisitionDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prRequisitionDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemDeliveryDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prItemDeliveryDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemDeliveryDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prItemDeliveryDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requesterFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.requester',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'costCenterFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.costCenter',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'profitCenterFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.profitCenter',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesDocNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.salesDocNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesDocumentItemFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.salesDocumentItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsElementFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.wbsElement',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'networkFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.network',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.orderNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mItemFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.mItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmationCategoryFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmationCategory',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbSapRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbSapRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbSapLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbSapLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaSapRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaSapRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaSapLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaSapLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbSapRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbSapRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbSapLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbSapLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'referenceFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.reference',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverLocationFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliverLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'exceptionMessageNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.exceptionMessageNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdScheduleDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prdScheduleDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdScheduleDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prdScheduleDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dlvSubtractScheduleFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.dlvSubtractSchedule',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateIsOnTimeFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateIsOnTime',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'releaseIndicatorFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.releaseIndicator',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isUploadQualityFileFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isUploadQualityFile',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'uploadDateFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.uploadDate',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliverStatus',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiveStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.receiveStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '11', text: '104退货'},
                {value: '12', text: '105质检完成'},
                {value: '13', text: '105检验收货'},
                {value: '14', text: '105部分收货'},
                {value: '15', text: '106退货'},
                {value: '16', text: '换修货'},
                {value: '17', text: '换修货取走'},
                {value: '18', text: '换修货返回'},
                {value: '19', text: '未入库'},
                {value: '1', text: '未到货'},
                {value: '2', text: '已入厂'},
                {value: '3', text: '异常到货'},
                {value: '4', text: '异常退货'},
                {value: '5', text: '101外协质检'},
                {value: '6', text: '101收货'},
                {value: '7', text: '101部分到货'},
                {value: '8', text: '102退货'},
                {value: '9', text: '103收货'},
                {value: '20', text: '已入库'},
                {value: '10', text: '103部分到货'}
            ]
        }
    },
    {
        key: 'receiveDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.receiveDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiveDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.receiveDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incomingTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incomingTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorContractFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorContract',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '已上传'},
                {value: '2', text: '未上传'}
            ]
        }
    },
    {
        key: 'isOpenFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isOpen',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'netOrderValueFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.netOrderValue',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'currencyKeyFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.currencyKey',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isAsnFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isAsn',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isSameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isSame',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isBuyerUploadedContractFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isBuyerUploadedContract',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'buyerUploadedContractTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.buyerUploadedContractTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'buyerUploadedContractTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.buyerUploadedContractTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnSapDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.returnSapDateRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnSapDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.returnSapDateLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isConfirmSapFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isConfirmSap',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmCountFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmCount',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.supportTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.supportTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.supportStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '未维护'},
                {value: '1', text: '已维护'}
            ]
        }
    },
    {
        key: 'projectNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.projectName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pmNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.pmName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cpmNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.cpmName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.omName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastModifiedExtInspectionInspectorNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.lastModifiedExtInspectionInspectorName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastModifiedExtInspectionStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.lastModifiedExtInspectionStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '未检验'},
                {value: '1', text: '检验合格'},
                {value: '2', text: '检验不合格'},
                {value: '3', text: '放弃检验'}
            ]
        }
    },
    {
        key: 'hasGenerateDeliverListFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.hasGenerateDeliverList',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'filterByNeedReadRequireDateChangeHistoryFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.filterByNeedReadRequireDateChangeHistory',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sdcOtdFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.sdcOtd',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sdrOtdFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.sdrOtd',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isCriticalFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isCritical',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
];
const cpmFilterConfigs = [
    {
        key: 'purchasingDocNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocItemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'objectCreatorFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.objectCreator',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.creatorName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingGroupFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingGroup',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorAccountNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorAccountNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameEnFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorNameEn',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameZhFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorNameZh',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms1Filter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incoterms1',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms2Filter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incoterms2',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plantFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.plant',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'accountAssignmentCategoryFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.accountAssignmentCategory',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemCategoryFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocItemCategory',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.materialNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bulkFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.bulk',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialShortTextFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.materialShortText',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderQuantityFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseOrderQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderUnitFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseOrderUnit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poGrQuantityFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.poGrQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poOpenGrQuantityFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.poOpenGrQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCreateDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemCreateDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCreateDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemCreateDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemDeliveryDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemDeliveryDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemDeliveryDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemDeliveryDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageLocationFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.storageLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'goodsReceiptProcessingTimeFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.goodsReceiptProcessingTime',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseRequisitionNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionItemNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseRequisitionItemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prRequisitionDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prRequisitionDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemDeliveryDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prItemDeliveryDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemDeliveryDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prItemDeliveryDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requesterFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.requester',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'costCenterFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.costCenter',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'profitCenterFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.profitCenter',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesDocNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.salesDocNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesDocumentItemFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.salesDocumentItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsElementFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.wbsElement',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'networkFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.network',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.orderNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mItemFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.mItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmationCategoryFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmationCategory',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbSapRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbSapRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbSapLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbSapLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaSapRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaSapRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaSapLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaSapLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbSapRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbSapRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbSapLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbSapLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'referenceFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.reference',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverLocationFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliverLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'exceptionMessageNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.exceptionMessageNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdScheduleDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prdScheduleDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdScheduleDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prdScheduleDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dlvSubtractScheduleFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.dlvSubtractSchedule',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateIsOnTimeFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateIsOnTime',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'releaseIndicatorFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.releaseIndicator',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isUploadQualityFileFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isUploadQualityFile',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'uploadDateFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.uploadDate',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliverStatus',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiveStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.receiveStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '11', text: '104退货'},
                {value: '12', text: '105质检完成'},
                {value: '13', text: '105检验收货'},
                {value: '14', text: '105部分收货'},
                {value: '15', text: '106退货'},
                {value: '16', text: '换修货'},
                {value: '17', text: '换修货取走'},
                {value: '18', text: '换修货返回'},
                {value: '19', text: '未入库'},
                {value: '1', text: '未到货'},
                {value: '2', text: '已入厂'},
                {value: '3', text: '异常到货'},
                {value: '4', text: '异常退货'},
                {value: '5', text: '101外协质检'},
                {value: '6', text: '101收货'},
                {value: '7', text: '101部分到货'},
                {value: '8', text: '102退货'},
                {value: '9', text: '103收货'},
                {value: '20', text: '已入库'},
                {value: '10', text: '103部分到货'}
            ]
        }
    },
    {
        key: 'receiveDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.receiveDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiveDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.receiveDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incomingTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incomingTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorContractFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorContract',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '已上传'},
                {value: '2', text: '未上传'}
            ]
        }
    },
    {
        key: 'isOpenFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isOpen',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'netOrderValueFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.netOrderValue',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'currencyKeyFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.currencyKey',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isAsnFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isAsn',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isSameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isSame',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isBuyerUploadedContractFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isBuyerUploadedContract',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'buyerUploadedContractTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.buyerUploadedContractTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'buyerUploadedContractTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.buyerUploadedContractTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnSapDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.returnSapDateRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnSapDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.returnSapDateLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isConfirmSapFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isConfirmSap',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmCountFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmCount',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.supportTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.supportTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.supportStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '未维护'},
                {value: '1', text: '已维护'}
            ]
        }
    },
    {
        key: 'projectNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.projectName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pmNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.pmName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cpmNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.cpmName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.omName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastModifiedExtInspectionInspectorNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.lastModifiedExtInspectionInspectorName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastModifiedExtInspectionStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.lastModifiedExtInspectionStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '未检验'},
                {value: '1', text: '检验合格'},
                {value: '2', text: '检验不合格'},
                {value: '3', text: '放弃检验'}
            ]
        }
    }
];
const vendorFilterConfigs = [
    {
        key: 'purchasingDocNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocItemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'objectCreatorFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.objectCreator',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.creatorName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingGroupFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingGroup',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorAccountNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorAccountNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameEnFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorNameEn',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameZhFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorNameZh',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms1Filter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incoterms1',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms2Filter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incoterms2',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'accountAssignmentCategoryFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.accountAssignmentCategory',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemCategoryFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocItemCategory',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.materialNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bulkFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.bulk',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialShortTextFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.materialShortText',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderQuantityFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseOrderQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderUnitFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseOrderUnit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poGrQuantityFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.poGrQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poOpenGrQuantityFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.poOpenGrQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCreateDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemCreateDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCreateDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemCreateDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemDeliveryDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemDeliveryDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemDeliveryDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemDeliveryDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseRequisitionNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionItemNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseRequisitionItemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requesterFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.requester',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsElementFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.wbsElement',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.orderNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mItemFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.mItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmationCategoryFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmationCategory',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbSapRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbSapRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbSapLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbSapLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaSapRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaSapRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaSapLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaSapLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbSapRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbSapRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbSapLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbSapLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'referenceFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.reference',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverLocationFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliverLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdScheduleDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prdScheduleDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdScheduleDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prdScheduleDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dlvSubtractScheduleFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.dlvSubtractSchedule',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateIsOnTimeFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateIsOnTime',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isUploadQualityFileFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isUploadQualityFile',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'uploadDateFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.uploadDate',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliverStatus',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiveStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.receiveStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '11', text: '104退货'},
                {value: '12', text: '105质检完成'},
                {value: '13', text: '105检验收货'},
                {value: '14', text: '105部分收货'},
                {value: '15', text: '106退货'},
                {value: '16', text: '换修货'},
                {value: '17', text: '换修货取走'},
                {value: '18', text: '换修货返回'},
                {value: '19', text: '未入库'},
                {value: '1', text: '未到货'},
                {value: '2', text: '已入厂'},
                {value: '3', text: '异常到货'},
                {value: '4', text: '异常退货'},
                {value: '5', text: '101外协质检'},
                {value: '6', text: '101收货'},
                {value: '7', text: '101部分到货'},
                {value: '8', text: '102退货'},
                {value: '9', text: '103收货'},
                {value: '20', text: '已入库'},
                {value: '10', text: '103部分到货'}
            ]
        }
    },
    {
        key: 'receiveDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.receiveDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiveDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.receiveDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incomingTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incomingTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorContractFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorContract',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '已上传'},
                {value: '2', text: '未上传'}
            ]
        }
    },
    {
        key: 'isOpenFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isOpen',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isSameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isSame',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'buyerUploadedContractTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.buyerUploadedContractTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'buyerUploadedContractTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.buyerUploadedContractTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnSapDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.returnSapDateRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnSapDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.returnSapDateLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isConfirmSapFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isConfirmSap',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmCountFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmCount',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.supportTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.supportTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.supportStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '未维护'},
                {value: '1', text: '已维护'}
            ]
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pmNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.pmName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastModifiedExtInspectionInspectorNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.lastModifiedExtInspectionInspectorName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastModifiedExtInspectionStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.lastModifiedExtInspectionStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '未检验'},
                {value: '1', text: '检验合格'},
                {value: '2', text: '检验不合格'},
                {value: '3', text: '放弃检验'}
            ]
        }
    },
    {
        key: 'hasGenerateDeliverListFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.hasGenerateDeliverList',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'filterByNeedReadRequireDateChangeHistoryFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.filterByNeedReadRequireDateChangeHistory',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    }
];
const sithFilterConfigs = [
    {
        key: 'purchasingDocNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocItemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'objectCreatorFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.objectCreator',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.creatorName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingGroupFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingGroup',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorAccountNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorAccountNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameEnFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorNameEn',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameZhFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorNameZh',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms1Filter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incoterms1',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms2Filter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incoterms2',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plantFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.plant',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'accountAssignmentCategoryFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.accountAssignmentCategory',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemCategoryFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchasingDocItemCategory',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.materialNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bulkFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.bulk',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialShortTextFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.materialShortText',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderQuantityFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseOrderQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderUnitFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseOrderUnit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poGrQuantityFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.poGrQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poOpenGrQuantityFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.poOpenGrQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCreateDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemCreateDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCreateDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemCreateDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemDeliveryDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemDeliveryDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemDeliveryDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.itemDeliveryDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageLocationFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.storageLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'goodsReceiptProcessingTimeFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.goodsReceiptProcessingTime',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseRequisitionNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionItemNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.purchaseRequisitionItemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prRequisitionDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prRequisitionDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemDeliveryDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prItemDeliveryDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemDeliveryDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prItemDeliveryDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requesterFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.requester',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'costCenterFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.costCenter',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'profitCenterFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.profitCenter',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesDocNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.salesDocNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesDocumentItemFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.salesDocumentItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsElementFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.wbsElement',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'networkFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.network',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.orderNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mItemFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.mItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmationCategoryFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmationCategory',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbSapRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbSapRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbSapLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbSapLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateAbLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaSapRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaSapRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaSapLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaSapLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateLaLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbSapRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbSapRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbSapLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbSapLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateTbLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'referenceFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.reference',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverLocationFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliverLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'exceptionMessageNumberFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.exceptionMessageNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdScheduleDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prdScheduleDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdScheduleDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.prdScheduleDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dlvSubtractScheduleFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.dlvSubtractSchedule',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateIsOnTimeFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliveryDateIsOnTime',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'releaseIndicatorFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.releaseIndicator',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isUploadQualityFileFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isUploadQualityFile',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'uploadDateFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.uploadDate',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.deliverStatus',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiveStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.receiveStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '11', text: '104退货'},
                {value: '12', text: '105质检完成'},
                {value: '13', text: '105检验收货'},
                {value: '14', text: '105部分收货'},
                {value: '15', text: '106退货'},
                {value: '16', text: '换修货'},
                {value: '17', text: '换修货取走'},
                {value: '18', text: '换修货返回'},
                {value: '19', text: '未入库'},
                {value: '1', text: '未到货'},
                {value: '2', text: '已入厂'},
                {value: '3', text: '异常到货'},
                {value: '4', text: '异常退货'},
                {value: '5', text: '101外协质检'},
                {value: '6', text: '101收货'},
                {value: '7', text: '101部分到货'},
                {value: '8', text: '102退货'},
                {value: '9', text: '103收货'},
                {value: '20', text: '已入库'},
                {value: '10', text: '103部分到货'}
            ]
        }
    },
    {
        key: 'receiveDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.receiveDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiveDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.receiveDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incomingTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.incomingTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorContractFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.vendorContract',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '已上传'},
                {value: '2', text: '未上传'}
            ]
        }
    },
    {
        key: 'isOpenFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isOpen',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isAsnFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isAsn',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isSameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isSame',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isBuyerUploadedContractFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isBuyerUploadedContract',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'buyerUploadedContractTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.buyerUploadedContractTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'buyerUploadedContractTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.buyerUploadedContractTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnSapDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.returnSapDateRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnSapDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.returnSapDateLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isConfirmSapFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isConfirmSap',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmCountFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.confirmCount',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.supportTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.supportTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.supportStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '未维护'},
                {value: '1', text: '已维护'}
            ]
        }
    },
    {
        key: 'projectNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.projectName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pmNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.pmName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cpmNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.cpmName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.omName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastModifiedExtInspectionInspectorNameFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.lastModifiedExtInspectionInspectorName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastModifiedExtInspectionStatusFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.lastModifiedExtInspectionStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '未检验'},
                {value: '1', text: '检验合格'},
                {value: '2', text: '检验不合格'},
                {value: '3', text: '放弃检验'}
            ]
        }
    },
    {
        key: 'filterByNeedReadRequireDateChangeHistoryFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.filterByNeedReadRequireDateChangeHistory',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sdcOtdFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.sdcOtd',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sdrOtdFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.sdrOtd',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isCriticalFilter',
        label: 'label.sith.stool.sithMesStoolPo.filter.isCritical',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'purchasingDocNumber',
        label: 'label.sith.stool.sithMesStoolPo.entity.purchasingDocNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemNumber',
        label: 'label.sith.stool.sithMesStoolPo.entity.purchasingDocItemNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocDate',
        label: 'label.sith.stool.sithMesStoolPo.entity.purchasingDocDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'objectCreator',
        label: 'label.sith.stool.sithMesStoolPo.entity.objectCreator',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorName',
        label: 'label.sith.stool.sithMesStoolPo.entity.creatorName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingGroup',
        label: 'label.sith.stool.sithMesStoolPo.entity.purchasingGroup',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorAccountNumber',
        label: 'label.sith.stool.sithMesStoolPo.entity.vendorAccountNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameEn',
        label: 'label.sith.stool.sithMesStoolPo.entity.vendorNameEn',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameZh',
        label: 'label.sith.stool.sithMesStoolPo.entity.vendorNameZh',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms1',
        label: 'label.sith.stool.sithMesStoolPo.entity.incoterms1',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incoterms2',
        label: 'label.sith.stool.sithMesStoolPo.entity.incoterms2',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deletion',
        label: 'label.sith.stool.sithMesStoolPo.entity.deletion',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plant',
        label: 'label.sith.stool.sithMesStoolPo.entity.plant',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'accountAssignmentCategory',
        label: 'label.sith.stool.sithMesStoolPo.entity.accountAssignmentCategory',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingDocItemCategory',
        label: 'label.sith.stool.sithMesStoolPo.entity.purchasingDocItemCategory',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialNumber',
        label: 'label.sith.stool.sithMesStoolPo.entity.materialNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialShortText',
        label: 'label.sith.stool.sithMesStoolPo.entity.materialShortText',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialBatchManagementIndicator',
        label: 'label.sith.stool.sithMesStoolPo.entity.materialBatchManagementIndicator',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialMinRemainingShelfLife',
        label: 'label.sith.stool.sithMesStoolPo.entity.materialMinRemainingShelfLife',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'totalShelfLife',
        label: 'label.sith.stool.sithMesStoolPo.entity.totalShelfLife',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderQuantity',
        label: 'label.sith.stool.sithMesStoolPo.entity.purchaseOrderQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseOrderUnit',
        label: 'label.sith.stool.sithMesStoolPo.entity.purchaseOrderUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poGrQuantity',
        label: 'label.sith.stool.sithMesStoolPo.entity.poGrQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poOpenGrQuantity',
        label: 'label.sith.stool.sithMesStoolPo.entity.poOpenGrQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCreateDate',
        label: 'label.sith.stool.sithMesStoolPo.entity.itemCreateDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemDeliveryDate',
        label: 'label.sith.stool.sithMesStoolPo.entity.itemDeliveryDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageLocation',
        label: 'label.sith.stool.sithMesStoolPo.entity.storageLocation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'goodsReceiptProcessingTime',
        label: 'label.sith.stool.sithMesStoolPo.entity.goodsReceiptProcessingTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionNumber',
        label: 'label.sith.stool.sithMesStoolPo.entity.purchaseRequisitionNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseRequisitionItemNumber',
        label: 'label.sith.stool.sithMesStoolPo.entity.purchaseRequisitionItemNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prRequisitionDate',
        label: 'label.sith.stool.sithMesStoolPo.entity.prRequisitionDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemDeliveryDate',
        label: 'label.sith.stool.sithMesStoolPo.entity.prItemDeliveryDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requester',
        label: 'label.sith.stool.sithMesStoolPo.entity.requester',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'costCenter',
        label: 'label.sith.stool.sithMesStoolPo.entity.costCenter',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'profitCenter',
        label: 'label.sith.stool.sithMesStoolPo.entity.profitCenter',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesDocNumber',
        label: 'label.sith.stool.sithMesStoolPo.entity.salesDocNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesDocumentItem',
        label: 'label.sith.stool.sithMesStoolPo.entity.salesDocumentItem',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsElement',
        label: 'label.sith.stool.sithMesStoolPo.entity.wbsElement',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'network',
        label: 'label.sith.stool.sithMesStoolPo.entity.network',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderNumber',
        label: 'label.sith.stool.sithMesStoolPo.entity.orderNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mItem',
        label: 'label.sith.stool.sithMesStoolPo.entity.mItem',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmationCategory',
        label: 'label.sith.stool.sithMesStoolPo.entity.confirmationCategory',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAbSap',
        label: 'label.sith.stool.sithMesStoolPo.entity.deliveryDateAbSap',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateAb',
        label: 'label.sith.stool.sithMesStoolPo.entity.deliveryDateAb',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLaSap',
        label: 'label.sith.stool.sithMesStoolPo.entity.deliveryDateLaSap',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateLa',
        label: 'label.sith.stool.sithMesStoolPo.entity.deliveryDateLa',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTbSap',
        label: 'label.sith.stool.sithMesStoolPo.entity.deliveryDateTbSap',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryDateTb',
        label: 'label.sith.stool.sithMesStoolPo.entity.deliveryDateTb',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'reference',
        label: 'label.sith.stool.sithMesStoolPo.entity.reference',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverLocation',
        label: 'label.sith.stool.sithMesStoolPo.entity.deliverLocation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'exceptionMessageNumber',
        label: 'label.sith.stool.sithMesStoolPo.entity.exceptionMessageNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdScheduleDate',
        label: 'label.sith.stool.sithMesStoolPo.entity.prdScheduleDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dlvSubtractSchedule',
        label: 'label.sith.stool.sithMesStoolPo.entity.dlvSubtractSchedule',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'releaseIndicator',
        label: 'label.sith.stool.sithMesStoolPo.entity.releaseIndicator',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isUploadQualityFile',
        label: 'label.sith.stool.sithMesStoolPo.entity.isUploadQualityFile',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'uploadDate',
        label: 'label.sith.stool.sithMesStoolPo.entity.uploadDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliverStatus',
        label: 'label.sith.stool.sithMesStoolPo.entity.deliverStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiveStatus',
        label: 'label.sith.stool.sithMesStoolPo.entity.receiveStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiveDate',
        label: 'label.sith.stool.sithMesStoolPo.entity.receiveDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorContract',
        label: 'label.sith.stool.sithMesStoolPo.entity.vendorContract',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '已上传'},
                {value: '2', text: '未上传'}
            ]
        }
    },
    {
        key: 'netOrderValue',
        label: 'label.sith.stool.sithMesStoolPo.entity.netOrderValue',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'currencyKey',
        label: 'label.sith.stool.sithMesStoolPo.entity.currencyKey',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isBuyerUploadedContract',
        label: 'label.sith.stool.sithMesStoolPo.entity.isBuyerUploadedContract',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'buyerUploadedContractTime',
        label: 'label.sith.stool.sithMesStoolPo.entity.buyerUploadedContractTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmTime',
        label: 'label.sith.stool.sithMesStoolPo.entity.confirmTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmCount',
        label: 'label.sith.stool.sithMesStoolPo.entity.confirmCount',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPo.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportTime',
        label: 'label.sith.stool.sithMesStoolPo.entity.supportTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supportStatus',
        label: 'label.sith.stool.sithMesStoolPo.entity.supportStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionPoint',
        label: 'label.sith.stool.sithMesStoolPo.entity.inspectionPoint',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poReportList',
        label: 'label.sith.stool.sithMesStoolPo.entity.poReport',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'poReport'
        }
    },
    {
        key: 'poContractReportList',
        label: 'label.sith.stool.sithMesStoolPo.entity.poContractReport',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'poContractReport'
        }
    },
    {
        key: 'poVendorContractReportList',
        label: 'label.sith.stool.sithMesStoolPo.entity.poVendorContractReport',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'poVendorContractReport'
        }
    },
    {
        key: 'poAsnReportList',
        label: 'label.sith.stool.sithMesStoolPo.entity.poAsnReportList',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'poAsnReportList'
        }
    },
    {
        key: 'qualityFiles',
        label: 'label.sith.stool.sithMesStoolPo.entity.qualityFileIds',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'qualityFileIds'
        }
    },
    {
        key: 'extInspectionRequestAttachmentIds',
        label: 'label.sith.stool.sithMesStoolPo.entity.extInspectionRequestAttachmentIds',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'extInspectionRequestAttachmentIds'
        }
    }
]

export {
    SithMesStoolPo, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs, cpmFilterConfigs, vendorFilterConfigs, sithFilterConfigs

    , cpmVoConfigs, vendorVoConfigs, sithVoConfigs
}
